import React, { useRef } from 'react';
import HeroLottie from '../../income-tax/page-sections/hero-section-new/lottie';
import HeroFooter from '../../income-tax/page-sections/hero-section-new/footer';
import { AnimatedContainer } from '../../income-tax/page-sections/hero-section-new/styles';
import HeroCard from './hero-card';
import HomepageRefundStrip from '../homepage-refund-strip';
import HomepageStickyCTA from '../homepage-sticky-CTA';
import { FIRST_FOLD_HERO_CARDS, FIRST_FOLD_CONSTANTS } from './constants';

const FirstFold: React.FC = () => {
  const heroCardsRef = useRef<HTMLDivElement>(null);
  // Data from constants
  const { platformText, platformLogos, statistics } = FIRST_FOLD_CONSTANTS;

  return (
    <AnimatedContainer>
      <div className={`bg-pink-brand`}>
        <div
          className="bg-no-repeat bg-right-top"
          style={{
            backgroundImage:
              'url("https://assets.clear.in/cleartax/images/1725535759_righttop.svg")',
            backgroundSize: '17%',
          }}
        >
          <div className="flex justify-between bg-pink-brand sm:w-full wg-container mx-auto sm:h-[434px] xl:h-[529px] lg:h-[494px] md:h-[320px] sm:pt-4">
            <div className="relative sm:pt-2 sm:px-4 sm:w-full flex flex-col lg:pl-0 lg:pr-0 md:pl-5 sm:pl-0 sm:pr-0 sm:items-center sm:text-center lg:w-1/2">
              {/* Refund Strip */}
              <HomepageRefundStrip />

              {/* Headings */}
              <h1>
                <div
                  className="font-bold text-5xl hidden text-font-500 opacity-0 translate-y-12 animate-slideIn xl:block md:block md:text-s-32 md:pr-4"
                  style={{ lineHeight: '110%' }}
                >
                  Get Maximum Tax Refund <br />
                </div>
                <div
                  className="font-bold text-3xl hidden sm:block lg:block text-font-500 sm:text-center opacity-0 translate-y-12 animate-slideIn lg:text-5xl"
                  style={{ lineHeight: '110%' }}
                >
                  Get Maximum <br />
                  Tax Refund
                </div>
              </h1>

              {/* Hero Cards Section */}
              <div
                ref={heroCardsRef}
                className="pt-14 flex gap-6 opacity-0 animate-slideUp animate-delay-300 sm:absolute sm:top-3/4 md:absolute md:top-3/4 md:left-4 md:right-4 md:pt-0 z-10 relative"
              >
                {FIRST_FOLD_HERO_CARDS.map((card, index) => (
                  <HeroCard key={index} {...card} />
                ))}
              </div>

              {/* Reuse HeroLottie for mobile */}
              <HeroLottie className="hidden sm:block pl-[61px] h-[294px] opacity-0 translate-y-12 animate-slideIn pointer-events-none sm:absolute sm:bottom-0 z-0" />
            </div>

            {/* Reuse HeroLottie for desktop */}
            <HeroLottie
              className="hidden lg:block xl:h-[529px] opacity-0 translate-y-12 animate-slideIn lg:h-[494px] xl:block lg:items-end md:block md:pr-3 md:w-[320px] pointer-events-none z-0"
              id="lottie-container"
            />
          </div>
        </div>

        {/* Reuse HeroFooter component */}
        <HeroFooter
          platformText={platformText}
          platformLogos={platformLogos}
          statistics={statistics}
          classname="md:pt-44 sm:pt-32"
        />
      </div>

      {/* Sticky CTA Component */}
      <HomepageStickyCTA heroCardsRef={heroCardsRef} />
    </AnimatedContainer>
  );
};

export default FirstFold;
